import '@/services/datadog/install';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import './index.css';
import './i18n';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { App } from './App';
import { MuiTheme } from './shared/MuiTheme';
import { FeatureFlagProvider } from './components/FeatureFlagProvider';
import { initFeatureFlags } from './services/featureFlags';

initFeatureFlags();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={MuiTheme}>
      <FeatureFlagProvider>
        <App />
      </FeatureFlagProvider>
    </ThemeProvider>
  </React.StrictMode>
);
